<template>
	<client-only>
		<NuxtLayout>
			<NuxtPage #="{ Component }">
				<component :is="Component" />
			</NuxtPage>
		</NuxtLayout>
	</client-only>
</template>
<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const { locale } = useI18n();
console.log(locale.value, 'locale.value');

// const { defaultLocale } = reactive({
// 	defaultLocale: en,
// });
</script>
